import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M44 28C44 19.1634 36.8366 12 28 12C19.1634 12 12 19.1634 12 28C12 36.8366 19.1634 44 28 44V56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56V44C36.8366 44 44 36.8366 44 28Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 56

/**
 * Circle cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */

export const CircleCutoutShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default CircleCutoutShape

